import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2, Users as UsersIcon, Mail, Phone, Cake, Coins } from "lucide-react";
import { api, errorMessage } from "../lib/api";

export default function AdminUsers() {
  const [users, setUsers] = useState([]);
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api.get("/admin/users")
      .then(r => setUsers(r.data || []))
      .catch(e => toast.error(errorMessage(e)))
      .finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  const remove = async (u) => {
    if (!window.confirm(`Delete ${u.full_name} (@${u.username})? This cannot be undone.`)) return;
    try {
      await api.delete(`/admin/users/${u.id}`);
      setUsers(us => us.filter(x => x.id !== u.id));
      toast.success("User deleted");
    } catch (e) { toast.error(errorMessage(e)); }
  };

  const filtered = users.filter(u => {
    if (!q.trim()) return true;
    const s = q.trim().toLowerCase();
    return [u.full_name, u.username, u.email, u.phone].some(v => (v || "").toLowerCase().includes(s));
  });

  return (
    <div data-testid="admin-users">
      <div className="mb-6 flex items-end justify-between gap-3 flex-wrap">
        <div>
          <h1 className="font-display font-extrabold text-3xl md:text-4xl flex items-center gap-2"><UsersIcon className="w-7 h-7 text-[#FF1F87]" /> Customers</h1>
          <p className="text-gray-500 mt-1 text-sm">{users.length} signed-up customer{users.length === 1 ? "" : "s"} · all auto-subscribed to your email list.</p>
        </div>
        <input
          className="input-base !py-2 !w-64"
          placeholder="Search name, email, phone…"
          value={q}
          onChange={e => setQ(e.target.value)}
          data-testid="admin-users-search"
        />
      </div>

      {loading ? (
        <p className="text-sm text-gray-500">Loading…</p>
      ) : filtered.length === 0 ? (
        <div className="bg-white border border-gray-100 rounded-2xl p-8 text-center">
          <UsersIcon className="w-10 h-10 text-gray-300 mx-auto mb-2" />
          <p className="text-gray-500 text-sm">{q ? "No matches." : "No customers yet — share your link to start signups."}</p>
        </div>
      ) : (
        <div className="bg-white border border-gray-100 rounded-2xl overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="bg-gray-50 text-left text-[11px] uppercase tracking-widest text-gray-500">
                <tr>
                  <th className="px-4 py-3">Name</th>
                  <th className="px-4 py-3">Username</th>
                  <th className="px-4 py-3"><Mail className="w-3 h-3 inline" /> Email</th>
                  <th className="px-4 py-3"><Phone className="w-3 h-3 inline" /> Phone</th>
                  <th className="px-4 py-3"><Cake className="w-3 h-3 inline" /> Birthday</th>
                  <th className="px-4 py-3"><Coins className="w-3 h-3 inline" /> Points</th>
                  <th className="px-4 py-3">Joined</th>
                  <th className="px-4 py-3"></th>
                </tr>
              </thead>
              <tbody>
                {filtered.map(u => (
                  <tr key={u.id} className="border-t border-gray-100 hover:bg-gray-50" data-testid={`admin-user-row-${u.username}`}>
                    <td className="px-4 py-3 font-bold">{u.full_name}</td>
                    <td className="px-4 py-3 text-gray-600">@{u.username}</td>
                    <td className="px-4 py-3 text-gray-600 break-all">{u.email || "—"}</td>
                    <td className="px-4 py-3 text-gray-600">{u.phone || "—"}</td>
                    <td className="px-4 py-3 text-gray-600">{u.birthday || "—"}</td>
                    <td className="px-4 py-3 font-bold text-[#FF1F87]">{u.points || 0}</td>
                    <td className="px-4 py-3 text-gray-500 text-xs">{u.created_at ? new Date(u.created_at).toLocaleDateString() : "—"}</td>
                    <td className="px-4 py-3 text-right">
                      <button
                        onClick={() => remove(u)}
                        className="text-gray-400 hover:text-red-500 p-1.5 rounded-lg hover:bg-red-50"
                        title="Delete user"
                        data-testid={`admin-user-delete-${u.username}`}
                      >
                        <Trash2 className="w-4 h-4" />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
